'use strict';

import { format } from 'date-fns';
import { getPerformances } from '../services/inventory';
import { loadComponent } from './utils/load-component';
import zonedDate from "../utils/zoned-date";

const KEYWORDS_CATEGORY_ID = 8;

loadComponent('performance-list', {
    props: {
        productionSeasons: {
            type: Array,
        },
        performances: {
            type: Array,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                Performances: [],
                HasAvailability: false,
                IsOnSale: false,
            },
        }
    },

    beforeMount() {
        getPerformances().then(performancesResponse => {
            if (this.performances.length) {
                return performancesResponse.filter(item => {
                    return this.performances.indexOf(item.PerformanceNumber) !== -1;
                });
            }

            if ( this.productionSeasons.length) {
                return performancesResponse.filter(perf => {
                    return this.productionSeasons.indexOf(perf.ProductionSeasonNumber) !== -1;
                });
            }

            return [];
        }).then(performancesResponse => {
            const now = zonedDate();

            this.ViewModel.Performances = performancesResponse.map(item => {

                if (!this.ViewModel.HasAvailability) {
                    this.ViewModel.HasAvailability = item.Availability > 0;
                }

                this.ViewModel.IsOnSale = item.StartSaleDate < now && now < item.EndSaleDate;

                return {
                    Date: format(item.PerformanceDate, 'EEE, MMM d, yyyy'),  //  Sat, April 23, 2022
                    Venue: item.Venue,
                    HasAvailability: item.HasAvailability,
                    Availability: item.Availability,
                    Time: format(item.PerformanceDate, 'h:mm aaa'),  //  8:00pm
                    Tags: Array.isArray(item.Keywords) ? item.Keywords.filter(keyword => {
                        return keyword.CategoryID === KEYWORDS_CATEGORY_ID;
                    }).map(keyword => {
                        return {
                            Label: keyword.Keyword,
                        }
                    }) : [],
                    Link: item.TicketLink,
                }
            });

            this.ViewModel.Loading = false;
        });
    },
});
